export const LOCATIONS_DEFAULT_FRONT_MESSAGE = 'This item is currently in storage and therefore we need 48 hours notice for viewings. Please contact us before travelling to view this item.';
